import { useState, useEffect } from "react";
import { api } from "@/lib/api";

/** Polls the count of sick-call kites a nurse flagged "needs to be seen sooner"
 *  and routed to this provider for an expedite decision. Powers the nav badge. */
export function useSickCallReviews(intervalMs = 60000) {
    const [count, setCount] = useState(0);
    useEffect(() => {
        let active = true;
        const fetchCount = () => api.get("/provider/sick-call-reviews")
            .then((r) => { if (active) setCount((r.data || []).length); })
            .catch(() => {});
        fetchCount();
        const id = setInterval(fetchCount, intervalMs);
        window.addEventListener("sickcall:updated", fetchCount);
        return () => { active = false; clearInterval(id); window.removeEventListener("sickcall:updated", fetchCount); };
    }, [intervalMs]);
    return count;
}
